import { Home, BookOpen, Star, Archive, type LucideIcon } from 'lucide-react';

export interface FilterOption {
  value: FilterType;
  label: string;
  icon: LucideIcon;
}

export const FILTER_OPTIONS: readonly FilterOption[] = [
  { value: undefined, label: 'Home', icon: Home },
  { value: 'unread', label: 'Unread', icon: BookOpen },
  { value: 'favorites', label: 'Favorites', icon: Star },
  { value: 'archived', label: 'Archived', icon: Archive },
] as const;

export type FilterType = 'unread' | 'favorites' | 'archived' | undefined;

export type FilterCountKey = 'all' | 'unread' | 'favorites' | 'archived';

export function getFilterCountKey(value: FilterType): FilterCountKey {
  return value ?? 'all';
}
